import { useConnectedAccount } from '@/providers/connectedAccount'
import { useUserContext } from '@/providers/user/useUserContext'
import Loading from '@/ui-components/Loading'
import ConnectedAccountDetail from '@/views/Dashboard/ConnectedAccountDetail'
import Welcome from '@/views/Dashboard/Welcome'

const DashboardPage: React.FC = () => {
  const { isLoading } = useConnectedAccount()

  const { activeConnectedAccountId } = useUserContext()
  if (isLoading) {
    return <Loading />
  }

  // TODO: add connect account list. If no connect accounts, show welcome page.
  if (activeConnectedAccountId) {
    return <ConnectedAccountDetail />
  }

  return <Welcome />
}

export default DashboardPage
